import { phpLimiter } from "types/global/container";

export const webAppWizardContainers = [
 {
  type: "php",
  icon: "PhpIcon",
  title: "docker.website.phpTitle",
  subtitle: "docker.website.phpSubtitle",
  section: "custom"
 },
 {
  type: "react",
  icon: "ReactIcon",
  title: "docker.website.reactTitle",
  subtitle: "docker.website.reactSubtitle",
  section: "web"
 },
 {
  type: "vue",
  icon: "VueIcon",
  title: "docker.website.vueTitle",
  subtitle: "docker.website.vueSubtitle",
  section: "web"
 },
 {
  type: "odoo",
  icon: "OdooIcon",
  title: "docker.website.odooTitle",
  subtitle: "docker.website.odooSubtitle",
  section: "custom"
 },
 {
  type: "wordpress",
  icon: "WordpressIcon",
  title: "docker.website.wordpressTitle",
  subtitle: "docker.website.wordpressSubtitle",
  section: "cms"
 },
 {
  type: "litespeed",
  icon: "LitespeedIcon",
  title: "docker.website.litespeedTitle",
  subtitle: "docker.website.litespeedSubtitle",
  section: "custom"
 },
 {
  type: "tomcat",
  icon: "TomcatIcon",
  title: "docker.website.tomcatTitle",
  subtitle: "docker.website.tomcatSubtitle",
  section: "custom"
 },
 {
  type: "prestashop",
  icon: "PrestashopIcon",
  title: "docker.website.prestashopTitle",
  subtitle: "docker.website.prestashopSubtitle",
  section: "cms"
 },
 {
  type: "joomla",
  icon: "JoomlaIcon",
  title: "docker.website.joomlaTitle",
  subtitle: "docker.website.joomlaSubtitle",
  section: "cms"
 },
 {
  type: "owncloud",
  icon: "OwncloudIcon",
  title: "docker.website.owncloudTitle",
  subtitle: "docker.website.owncloudSubtitle",
  section: "cms"
 },
 {
  type: "nodejs",
  icon: "NodejsIcon",
  title: "docker.website.nodeTitle",
  subtitle: "docker.website.nodeSubtitle",
  section: "web"
 },
 {
  type: "appointments",
  icon: "AppointmentsIcon",
  title: "docker.website.appointmentsTitle",
  subtitle: "docker.website.appointmentsSubtitle",
  section: "utility"
 }
];

export const wordpressPhpVersionLimiter: phpLimiter = [
 {
  version: "6.7.2",
  ph_not_wanted: "php-5.6"
 }
];

export const owncloudPhpVersionLimiter: phpLimiter = [
 {
  version: "10.15.2",
  ph_not_wanted: "php-5.6, php-8.0, php-8.1, php-8.2, php-8.3, php-8.4"
 }
];

export const prestashopPhpVersionLimiter: phpLimiter = [
 {
  version: "8.2.0",
  ph_not_wanted: "php-5.6, php-7.4, php-8.0, php-8.1"
 }
];

export const joomlaPhpVersionLimiter: phpLimiter = [
 {
  version: "5.2.4",
  ph_not_wanted: "php-5.6, php-7.4, php-8.0, php-8.1"
 }
];

export const easyappointmentsPhpVersionLimiter: phpLimiter = [
 {
  version: "1.5.1",
  ph_not_wanted: "php-5.6, php-7.4, php-8.0, php-8.1"
 }
];

export const pluginsList = [
 {
  name: "Redis",
  icon: "",
  container_name: "redis"
 },
 {
  name: "Memcache",
  icon: "",
  container_name: "memcached"
 }
];

export const owncloudParamList = [
 {
  param: "mail_from_address",
  type: "open_text",
  values: []
 },
 {
  param: "mail_domain",
  type: "open_text",
  values: []
 },
 {
  param: "mail_smtpmode",
  type: "open_text",
  values: []
 },
 {
  param: "mail_smtpauthtype",
  type: "open_text",
  values: []
 },
 {
  param: "mail_smtpauth",
  type: "select",
  values: ["true", "false"]
 },
 {
  param: "mail_smtpname",
  type: "open_text",
  values: []
 },
 {
  param: "mail_smtppassword",
  type: "open_password",
  values: []
 },
 {
  param: "mail_smtphost",
  type: "open_text",
  values: []
 },
 {
  param: "mail_smtpport",
  type: "select",
  values: ["587", "465", "25"]
 },
 {
  param: "mail_smtpsecure",
  type: "select",
  values: ["tls", "none"]
 }
];

export const easyappParamList = [
 {
  param: "easyappointments_from_name",
  type: "open_text",
  values: []
 },
 {
  param: "easyappointments_from_address",
  type: "open_text",
  values: []
 },
 {
  param: "easyappointments_reply_to",
  type: "open_text",
  values: []
 },
 {
  param: "easyappointments_smtp_user",
  type: "open_text",
  values: []
 },
 {
  param: "easyappointments_smtp_pass",
  type: "open_password",
  values: []
 },
 {
  param: "easyappointments_smtp_port",
  type: "select",
  values: ["588", "465", "25"]
 }
];

export const nginxParamList = [
 {
  param: "client_max_body_size",
  type: "open_number",
  values: []
 }
];
